import { Injectable } from '@angular/core';
import { StorageService } from '@shared/core';
import { EMPTY, Observable } from 'rxjs';

const AUTH_TOKEN = 'authToken';
const REFRESH_TOKEN = 'refreshToken';
const USER_INFO_TOKEN = 'userInfoToken';

@Injectable({
  providedIn: 'root',
})
export class DataStorageService extends StorageService {
  logout(): void {
    this.remove(AUTH_TOKEN);
    this.remove(REFRESH_TOKEN);
    this.remove(USER_INFO_TOKEN);
  }

  setUserData(data: unknown): void {
    this.set(USER_INFO_TOKEN, data);
  }

  clearUserData(): void {
    this.remove(USER_INFO_TOKEN);
  }

  getUserData<T = unknown>(): T | undefined {
    return this.get<T>(USER_INFO_TOKEN);
  }

  onUserDataChanged<T = unknown>(): Observable<T | undefined> {
    return this.watch(USER_INFO_TOKEN) ?? EMPTY;
  }

  getRefreshToken(): string | undefined {
    return this.get<string>(REFRESH_TOKEN);
  }

  setTokens(accessToken: string | undefined, refreshToken: string | undefined): void {
    this.set(AUTH_TOKEN, accessToken);
    this.set(REFRESH_TOKEN, refreshToken);
  }

  getAuthToken(): string | undefined {
    return this.get<string>(AUTH_TOKEN);
  }

  onAuthTokenChanged(): Observable<string | undefined> {
    return this.watch(AUTH_TOKEN) ?? EMPTY;
  }
}
